module.exports = __webpack_public_path__ + "static/media/icon-teamplayers-edit.96ce6288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teamplayers-edit.svg
// module id = 1856
// module chunks = 0